import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  id: "nav",
  class: "bg-base-100 drawer h-screen drawer-mobile"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("input", {
  id: "my-drawer-menu",
  type: "checkbox",
  class: "drawer-toggle"
}, null, -1)
const _hoisted_3 = {
  class: "drawer-content",
  style: {"scroll-behavior":"smooth","scroll-padding-top":"5rem"}
}
const _hoisted_4 = { class: "p-6 pb-16" }
const _hoisted_5 = { class: "drawer-side" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", {
  for: "my-drawer-menu",
  class: "drawer-overlay"
}, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "text-green-500 text-red-500 text-blue-500" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_Nav = _resolveComponent("Nav")!
  const _component_Login = _resolveComponent("Login")!
  const _component_Logout = _resolveComponent("Logout")!
  const _component_my_toast = _resolveComponent("my-toast")!
  const _component_my_confirm = _resolveComponent("my-confirm")!
  const _component_customer_contracts = _resolveComponent("customer-contracts")!

  return (!_ctx.loading)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_Header),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_router_view)
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createVNode(_component_Nav)
        ]),
        _createVNode(_component_Login),
        _createVNode(_component_Logout),
        _createVNode(_component_my_toast),
        _createVNode(_component_my_confirm),
        _createVNode(_component_customer_contracts),
        _hoisted_7
      ]))
    : _createCommentVNode("", true)
}